import {useContext} from 'react'
import {DocumentLoadDetailContext} from './DocumentLoadDetailContext'
import { DocumentQuickViewModalHeader } from './document-quick-view/DocumentQuickViewModalHeader'
import { DocumentQuickViewModalFormWrapper } from './document-quick-view/DocumentQuickViewModalFormWrapper'

const DocumentQuickViewModal = () => {
  const {isDocumentQuickViewModalOpen} = useContext(DocumentLoadDetailContext)
  return (
    <>
      {isDocumentQuickViewModalOpen && (
        <>
          <div>
            <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true'>
              <div className='modal-dialog modal-xl modal-dialog-centered '>
                <div className='modal-content'>
                  <DocumentQuickViewModalHeader />
                  <div className='modal-body scroll-y mx-5 mx-xl-5 my-2'>
                    <DocumentQuickViewModalFormWrapper />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='modal-backdrop fade show'></div>
        </>
      )}
    </>
  )
}

export {DocumentQuickViewModal}
